// extracted by mini-css-extract-plugin
module.exports = {"block":"index-module--block--35qIv","blockVideo":"index-module--blockVideo--1MKqP","blockBuy":"index-module--blockBuy--28VzZ","blockBuyM":"index-module--blockBuyM--1ECs8"};